import { useEffect, useState } from "react";
import api from "../lib/api";

export default function useMasterMaps() {
  const [m, setM] = useState({
    zones: [], branches: [], departments: [], designations: [],
    zoneMap: {}, branchMap: {}, deptMap: {}, desigMap: {}, loaded: false,
  });
  useEffect(() => {
    Promise.all(["zones", "branches", "departments", "designations"].map((e) => api.get(`/${e}`)))
      .then(([z, b, d, s]) => setM({
        zones: z.data, branches: b.data, departments: d.data, designations: s.data,
        zoneMap: Object.fromEntries(z.data.map((x) => [x.zone_id, x.zone_name])),
        branchMap: Object.fromEntries(b.data.map((x) => [x.branch_id, x.branch_name])),
        deptMap: Object.fromEntries(d.data.map((x) => [x.dept_id, x.dept_name])),
        desigMap: Object.fromEntries(s.data.map((x) => [x.desig_id, x.desig_name])),
        loaded: true,
      })).catch(() => {});
  }, []);
  return m;
}

export const selCls = "border border-gray-300 rounded-sm px-2.5 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#BF9B30]";
export const inputCls = "w-full border border-gray-300 rounded-sm px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#BF9B30]";
